module.exports = __webpack_public_path__ + "static/img/guide_e_sign_v3.1de79a8.png";